module.exports = __webpack_public_path__ + "static/img/24@2x.1ab76ecc.png";